// 文字列に空白（半角・全角スペース、タブ・改行等）が含まれているかを判定する。
// 含まれていれば true。先頭・末尾だけでなく、途中の空白も対象とする。
// （\s は JavaScript では全角スペース 　 も含む）
export function checkSpace(list: string[]): boolean {
  return list.some((str) => /\s/.test(str));
}
